import * as React from "react";
import {ValuableItem} from "@falcon/services";
import {ConfirmModal} from "@falcon/plugin-falcon-journey";
import ValuableItemModal from "../valuablesPage/ValuableItemModal";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {calculateValuablesTotalValue, getAmountToDisplay} from "../../../../../CommonFunctions";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

interface IProps {
    item: ValuableItem,
    interaction: any,
    cancelled: boolean
}

interface IState {
    showItemModal: boolean
    showRemoveConfirmation: boolean
    item: ValuableItem
}

export class SpecifiedItemInfoPlain extends React.Component<IProps & IWithRouterProps, IState> {

    constructor(props: IProps & IWithRouterProps) {
        super(props);

        this.state = {
            showItemModal: false,
            showRemoveConfirmation: false,
            item: this.props.item
        };
    }

    public render() {
        const valuableItems: ValuableItem[] = this.props.interaction.valuableItems;
        return (
            <>
                {this.renderItemPanel()}
                {this.state.showItemModal &&
                <ValuableItemModal {...this.props}
                                   show={this.state.showItemModal}
                                   hide={() => this.setState({showItemModal: false})}
                                   onConfirm={this.editItem}
                                   item={this.state.item}
                                   itemWordings={PluginTemplates.getSpecifiedItemWordings(this.state.item)}
                                   interactionId={this.props.interaction._id}
                                   totalValueOfItems={calculateValuablesTotalValue(valuableItems)}
                                   insuredValue={this.props.interaction.factors.insuredValue}/>}

                {this.state.showRemoveConfirmation &&
                <ConfirmModal show={this.state.showRemoveConfirmation}
                              onHide={() => this.setState({showRemoveConfirmation: false})}
                              onConfirm={() => this.removeItem(this.state.item!)}
                              confirmButtonText="Yes, please">
                    <div className="fs-20 font-weight-medium font-family-display">
                        Are you sure you want to remove this item from your cover?
                    </div>
                </ConfirmModal>}
            </>
        );
    }

    private renderItemPanel = (): React.ReactNode => {
        return (
            <>
                <div>{this.state.item.description}</div>
                <div><b>Cover inside and outside the home</b> for <b>£{this.state.item.value}</b></div>
                <div>Monthly price: <b>{getAmountToDisplay(this.state.item.premium)}</b></div>
                <div className="d-flex justify-content-between justify-content-md-start mt-2 font-weight-medium text-blue-1 text-decoration-underline">
                    {!this.props.cancelled && <span onClick={() => this.setState({showItemModal: true})} className="mr-5 cursor-pointer">
                        Edit
                    </span>}
                    {!this.props.cancelled && <span onClick={() => this.setState({showRemoveConfirmation: true})} className="cursor-pointer">
                        Remove
                    </span>}
                </div>
            </>
        )
    };

    private removeItem = (item: ValuableItem): void => {
        window.sessionStorage.removeItem("itemToProcess");
        window.sessionStorage.setItem("itemToProcess", JSON.stringify(item));
        this.props.navigate(`/journey/show/product/RentersInsurance/process/mtaRemoveItem/preset/${this.props.interaction._id}`);
    };

    private editItem = (item: ValuableItem): void => {
        this.setState({showItemModal: false, item});
    };
}

export default withRouter<IProps>(SpecifiedItemInfoPlain)
